import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PiggyBank } from "lucide-react";
import { formatNumber } from "@/lib/formatters";

const FinanceDataTable = ({ financeData }) => (
        <Card className="bg-white border border-[#E6E9F0] rounded-lg">
          <CardHeader className="border-b border-[#E6E9F0] pb-4">
            <CardTitle className="text-lg font-medium text-[#1F2A36] flex items-center gap-2">
              <PiggyBank className="w-5 h-5 text-[#103766]" />
              Detaljert økonomidata
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow className="bg-[#F6F8FB]">
                    <TableHead className="text-[#4B647F]">År</TableHead>
                    <TableHead className="text-[#4B647F] text-right">Inntekter</TableHead>
                    <TableHead className="text-[#4B647F] text-right">Utgifter</TableHead>
                    <TableHead className="text-[#4B647F] text-right">Investeringar</TableHead>
                    <TableHead className="text-[#4B647F] text-right">Lån</TableHead>
                    <TableHead className="text-[#4B647F] text-right">Gjeld</TableHead>
                    <TableHead className="text-[#4B647F] text-right">Premieavvik</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {financeData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} className="text-center text-[#8AA4BF] py-8">
                        Ingen data tilgjengeleg
                      </TableCell>
                    </TableRow>
                  ) : (
                    financeData.map((row) => (
                      <TableRow key={row.year} className="hover:bg-[#F6F8FB]/50">
                        <TableCell className="font-medium">{row.year}</TableCell>
                        <TableCell className="text-right">{formatNumber(row.inntekt)}</TableCell>
                        <TableCell className="text-right">{formatNumber(row.kostnad)}</TableCell>
                        <TableCell className="text-right">{formatNumber(row.investeringer)}</TableCell>
                        <TableCell className="text-right">{formatNumber(row.laan)}</TableCell>
                        <TableCell className="text-right">{formatNumber(row.gjeld)}</TableCell>
                        <TableCell className="text-right">{formatNumber(row.premieavvik)}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
);

export default FinanceDataTable;
